const safeJSONParse = (json: any) => {
  if (typeof json === 'string') {
    try {
      return JSON.parse(json)
    } catch (_) {
      return {}
    }
  }

  return json
}

export default safeJSONParse
